import { render, staticRenderFns } from "./DynamicSettingWidget.vue?vue&type=template&id=0ec0f674&scoped=true&"
import script from "./DynamicSettingWidget.vue?vue&type=script&lang=js&"
export * from "./DynamicSettingWidget.vue?vue&type=script&lang=js&"
import style0 from "./DynamicSettingWidget.vue?vue&type=style&index=0&id=0ec0f674&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec0f674",
  null
  
)

export default component.exports